import axios from 'axios';
import {
  AnalyzerLicense,
  CheckedModule,
  CreateAnalyzerLicenseDto,
  CreateAnalyzerDemoLicenseDto,
  CreatedLicense,
  InsertAnalyzerLicenseDto,
} from 'types';

export async function insertLicense(
  licenses: InsertAnalyzerLicenseDto[]
): Promise<AnalyzerLicense> {
  const url = `/api/analyzer-licenses`;

  try {
    const { data }: { data: AnalyzerLicense[] } = await axios.post(
      url,
      licenses
    );
    return data[0];
  } catch (err) {
    throw err;
  }
}

export async function createLicense(
  licenses: CreateAnalyzerLicenseDto[]
): Promise<CreatedLicense> {
  const url = `/api/analyzer-licenses/create`;

  try {
    const { data } = await axios.post(url, licenses);
    return data as CreatedLicense;
  } catch (err) {
    throw err;
  }
}

export async function createDemoLicense(
  licenses: CreateAnalyzerDemoLicenseDto[]
): Promise<CreatedLicense> {
  const url = `/api/analyzer-licenses/create/demo`;

  try {
    const { data } = await axios.post(url, licenses);
    return data as CreatedLicense;
  } catch (err) {
    throw err;
  }
}

export async function checkLicenseModules(
  license: CreateAnalyzerLicenseDto[]
): Promise<CheckedModule[]> {
  const url = `/api/analyzer-licenses/check-license-modules`;

  try {
    const { data } = await axios.post(url, license);
    return data as CheckedModule[];
  } catch (err) {
    throw err;
  }
}
